// extracted by mini-css-extract-plugin
module.exports = {"ul":"ul-12IGOnn9","last":"last-3E5P0vir ul-12IGOnn9"};